(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react-dom')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-dom'], factory) :
  (factory((global.bereSelect = {}),global.React,global.ReactDOM));
}(this, (function (exports,React,ReactDOM) { 'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  /* global define */

  (function () {

  	var hasOwn = {}.hasOwnProperty;

  	function classNames () {
  		var classes = [];

  		for (var i = 0; i < arguments.length; i++) {
  			var arg = arguments[i];
  			if (!arg) continue;

  			var argType = typeof arg;

  			if (argType === 'string' || argType === 'number') {
  				classes.push(arg);
  			} else if (Array.isArray(arg)) {
  				classes.push(classNames.apply(null, arg));
  			} else if (argType === 'object') {
  				for (var key in arg) {
  					if (hasOwn.call(arg, key) && arg[key]) {
  						classes.push(key);
  					}
  				}
  			}
  		}

  		return classes.join(' ');
  	}

  	if (module.exports) {
  		module.exports = classNames;
  	} else if (typeof undefined === 'function' && typeof undefined.amd === 'object' && undefined.amd) {
  		// register as 'classnames', consistent with npm package name
  		undefined('classnames', [], function () {
  			return classNames;
  		});
  	} else {
  		window.classNames = classNames;
  	}
  }());
  });

  var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */
  (function (global, factory) {
      module.exports = factory();
  }(commonjsGlobal, (function () {
      
      var REACT_STATICS = {
          childContextTypes: true,
          contextTypes: true,
          defaultProps: true,
          displayName: true,
          getDefaultProps: true,
          getDerivedStateFromProps: true,
          mixins: true,
          propTypes: true,
          type: true
      };
      
      var KNOWN_STATICS = {
          name: true,
          length: true,
          prototype: true,
          caller: true,
          callee: true,
          arguments: true,
          arity: true
      };
      
      var defineProperty = Object.defineProperty;
      var getOwnPropertyNames = Object.getOwnPropertyNames;
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var getPrototypeOf = Object.getPrototypeOf;
      var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
      
      return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
          if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
              
              if (objectPrototype) {
                  var inheritedComponent = getPrototypeOf(sourceComponent);
                  if (inheritedComponent && inheritedComponent !== objectPrototype) {
                      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                  }
              }
              
              var keys = getOwnPropertyNames(sourceComponent);
              
              if (getOwnPropertySymbols) {
                  keys = keys.concat(getOwnPropertySymbols(sourceComponent));
              }
              
              for (var i = 0; i < keys.length; ++i) {
                  var key = keys[i];
                  if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                      var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                      try { // Avoid failures from read-only properties
                          defineProperty(targetComponent, key, descriptor);
                      } catch (e) {}
                  }
              }
              
              return targetComponent;
          }
          
          return targetComponent;
      };
  })));
  });

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction = function emptyFunction() {};

  emptyFunction.thatReturns = makeEmptyFunction;
  emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
  emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
  emptyFunction.thatReturnsNull = makeEmptyFunction(null);
  emptyFunction.thatReturnsThis = function () {
    return this;
  };
  emptyFunction.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1 = emptyFunction;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var validateFormat = function validateFormat(format) {};

  {
    validateFormat = function validateFormat(format) {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    };
  }

  function invariant(condition, format, a, b, c, d, e, f) {
    validateFormat(format);

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  }

  var invariant_1 = invariant;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning = emptyFunction_1;

  {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1 = warning;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols) {
  			symbols = getOwnPropertySymbols(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  {
    var invariant$1 = invariant_1;
    var warning$1 = warning_1;
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }
          warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;

            var stack = getStack ? getStack() : '';

            warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
          }
        }
      }
    }
  }

  var checkPropTypes_1 = checkPropTypes;

  var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            invariant_1(
              false,
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              warning_1(
                false,
                'You are manually calling a React.PropTypes validation ' +
                'function for the `%s` prop on `%s`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                propFullName,
                componentName
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunction_1.thatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunction_1.thatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          warning_1(
            false,
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received %s at index %s.',
            getPostfixForTypeWarning(checker),
            i
          );
          return emptyFunction_1.thatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
      Symbol.for &&
      Symbol.for('react.element')) ||
      0xeac7;

    var isValidElement = function(object) {
      return typeof object === 'object' &&
        object !== null &&
        object.$$typeof === REACT_ELEMENT_TYPE;
    };

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
  }
  });

  function _typeof$1(obj) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
      _typeof$1 = function _typeof$$1(obj) {
        return _typeof(obj);
      };
    } else {
      _typeof$1 = function _typeof$$1(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
      };
    }

    return _typeof$1(obj);
  }

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose$1(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized$1(self);
  }

  function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf$$1(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
  }

  function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
  }

  function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf$$1(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$1(o, p);
  }

  function _assertThisInitialized$1(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  function enhanceWithClickOutside(WrappedComponent) {
    var componentName = WrappedComponent.displayName || WrappedComponent.name;

    var EnhancedComponent =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits$1(EnhancedComponent, _React$Component);

      function EnhancedComponent() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck$1(this, EnhancedComponent);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(EnhancedComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleClickOutside", function (e) {
          var domNode = _this.__domNode;

          if ((!domNode || !domNode.contains(e.target)) && typeof _this.__wrappedInstance.handleClickOutside === 'function') {
            _this.__wrappedInstance.handleClickOutside(e);
          }
        });

        return _this;
      }

      _createClass$1(EnhancedComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          document.addEventListener('click', this.handleClickOutside, true);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          document.removeEventListener('click', this.handleClickOutside, true);
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              wrappedRef = _this$props.wrappedRef,
              rest = _objectWithoutProperties$1(_this$props, ["wrappedRef"]);

          return React.createElement(WrappedComponent, _extends$1({}, rest, {
            ref: function ref(c) {
              _this2.__wrappedInstance = c;
              _this2.__domNode = ReactDOM.findDOMNode(c);
              wrappedRef && wrappedRef(c);
            }
          }));
        }
      }]);

      return EnhancedComponent;
    }(React.Component);

    EnhancedComponent.displayName = "clickOutside(".concat(componentName, ")");
    return hoistNonReactStatics(EnhancedComponent, WrappedComponent);
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction$1(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction$1 = function emptyFunction() {};

  emptyFunction$1.thatReturns = makeEmptyFunction$1;
  emptyFunction$1.thatReturnsFalse = makeEmptyFunction$1(false);
  emptyFunction$1.thatReturnsTrue = makeEmptyFunction$1(true);
  emptyFunction$1.thatReturnsNull = makeEmptyFunction$1(null);
  emptyFunction$1.thatReturnsThis = function () {
    return this;
  };
  emptyFunction$1.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1$1 = emptyFunction$1;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var validateFormat$1 = function validateFormat(format) {};

  {
    validateFormat$1 = function validateFormat(format) {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    };
  }

  function invariant$2(condition, format, a, b, c, d, e, f) {
    validateFormat$1(format);

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  }

  var invariant_1$1 = invariant$2;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning$2 = emptyFunction_1$1;

  {
    var printWarning$1 = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning$2 = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning$1.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1$1 = warning$2;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

  function toObject$1(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative$1() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject$1(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty$1.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols$1) {
  			symbols = getOwnPropertySymbols$1(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable$1.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;

  {
    var invariant$3 = invariant_1$1;
    var warning$3 = warning_1$1;
    var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$1;
    var loggedTypeFailures$1 = {};
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            invariant$3(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$3);
          } catch (ex) {
            error = ex;
          }
          warning$3(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
          if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures$1[error.message] = true;

            var stack = getStack ? getStack() : '';

            warning$3(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
          }
        }
      }
    }
  }

  var checkPropTypes_1$1 = checkPropTypes$1;

  var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1$1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            invariant_1$1(
              false,
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              warning_1$1(
                false,
                'You are manually calling a React.PropTypes validation ' +
                'function for the `%s` prop on `%s`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                propFullName,
                componentName
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunction_1$1.thatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        warning_1$1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunction_1$1.thatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        warning_1$1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunction_1$1.thatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          warning_1$1(
            false,
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received %s at index %s.',
            getPostfixForTypeWarning(checker),
            i
          );
          return emptyFunction_1$1.thatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign$1({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes$1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
      Symbol.for &&
      Symbol.for('react.element')) ||
      0xeac7;

    var isValidElement = function(object) {
      return typeof object === 'object' &&
        object !== null &&
        object.$$typeof === REACT_ELEMENT_TYPE;
    };

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1(isValidElement, throwOnDirectAccess);
  }
  });

  /**
   * 分组搜索选择框
   */

  var GroupSearchSelect =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(GroupSearchSelect, _React$Component);

    function GroupSearchSelect() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, GroupSearchSelect);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GroupSearchSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        active: false,
        searchKey: ''
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function () {
        _this.close();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
        _this.setState({
          active: !_this.state.active
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputFocus", function (e) {
        _this.setState({
          active: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputBlur", function () {
        _this.props.onBlur();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchChange", function (e) {
        var value = e.target.value;

        _this.setState({
          searchKey: value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleItemClick", function (item) {
        _this.setState({
          searchKey: item.text,
          active: false
        });

        _this.props.onChange(item);
      });

      return _this;
    }

    _createClass(GroupSearchSelect, [{
      key: "close",
      value: function close() {
        // 验证合法性
        // const {textField, valueField, groupField} = this.props
        // if(!this.props.list.find(item => item[textField] ===
        // this.state.searchKey)){ this.setState({ searchKey: '', }) }
        this.setState({
          searchKey: ''
        });
        this.setState({
          active: false
        });
      }
    }, {
      key: "getGroupList",
      value: function getGroupList(list, group) {
        return list.filter(function (d) {
          return d.group === group;
        });
      }
    }, {
      key: "getItem",
      value: function getItem() {
        var value = this.getValue();
        return this.props.list.find(function (item) {
          return item.value.toString() === value.toString();
        });
      }
    }, {
      key: "getValue",
      value: function getValue() {
        var current = this.props.value;
        return current ? typeof current === 'string' ? current : current.value ? current.value : '' : '';
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$groupsAndList = this.groupsAndList,
            groupList = _this$groupsAndList.list,
            groups = _this$groupsAndList.groups;
        var _this$props = this.props,
            className = _this$props.className,
            loading = _this$props.loading,
            style = _this$props.style;
        var val = this.getValue();
        return React.createElement("div", {
          className: classnames('tcd-15-search-select', {
            active: this.state.active
          }, className),
          style: style
        }, React.createElement("input", {
          type: "text",
          className: "search",
          placeholder: this.placeholder,
          value: this.state.searchKey,
          onFocus: this.handleInputFocus,
          onChange: this.handleSearchChange
        }), React.createElement("button", {
          type: "button",
          className: "select-caret",
          onClick: this.handleClick
        }, loading ? React.createElement("i", {
          className: "n-loading-icon"
        }) : React.createElement("i", {
          className: "icon-arrow-down"
        })), React.createElement("div", {
          className: "select-menu"
        }, groups.map(function (group, idx) {
          return React.createElement("div", {
            key: idx,
            className: "select-menu-item"
          }, React.createElement("div", {
            className: "select-menu-item-name"
          }, group), React.createElement("div", {
            className: "select-menu-item-list"
          }, _this2.getGroupList(groupList, group).map(function (item, idx) {
            return React.createElement("div", {
              key: idx,
              className: classnames('item', {
                selected: val === item.value
              })
            }, React.createElement("a", {
              href: "javascript:",
              onClick: function onClick() {
                _this2.handleItemClick(item);
              }
            }, item.text));
          })));
        })));
      }
    }, {
      key: "groupsAndList",
      get: function get() {
        var _this3 = this;

        var _this$props2 = this.props,
            textField = _this$props2.textField,
            valueField = _this$props2.valueField,
            groupField = _this$props2.groupField;
        var list = this.props.list.map(function (item) {
          return _objectSpread({}, item, {
            text: item[textField],
            value: item[valueField],
            group: item[groupField]
          });
        }).filter(function (item) {
          return item.text.toLowerCase().indexOf(_this3.state.searchKey.toLowerCase()) > -1;
        });
        var groups = Array.from(new Set(list.map(function (d) {
          return d.group;
        })));
        return {
          list: list,
          groups: groups
        };
      }
    }, {
      key: "placeholder",
      get: function get() {
        // const item = this.getItem()
        // return item ? item.text : this.props.placeholder
        var val = this.getValue();
        return val || this.props.placeholder;
      }
    }]);

    return GroupSearchSelect;
  }(React.Component);

  _defineProperty(GroupSearchSelect, "defaultProps", {
    list: [],
    value: null,
    placeholder: null,
    loading: false,
    onChange: function onChange() {},
    textField: 'text',
    valueField: 'value',
    groupField: 'group'
  });

  var GroupSearchSelect$1 = enhanceWithClickOutside(GroupSearchSelect);

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction$2(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction$2 = function emptyFunction() {};

  emptyFunction$2.thatReturns = makeEmptyFunction$2;
  emptyFunction$2.thatReturnsFalse = makeEmptyFunction$2(false);
  emptyFunction$2.thatReturnsTrue = makeEmptyFunction$2(true);
  emptyFunction$2.thatReturnsNull = makeEmptyFunction$2(null);
  emptyFunction$2.thatReturnsThis = function () {
    return this;
  };
  emptyFunction$2.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1$2 = emptyFunction$2;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var validateFormat$2 = function validateFormat(format) {};

  {
    validateFormat$2 = function validateFormat(format) {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    };
  }

  function invariant$4(condition, format, a, b, c, d, e, f) {
    validateFormat$2(format);

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  }

  var invariant_1$2 = invariant$4;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning$4 = emptyFunction_1$2;

  {
    var printWarning$2 = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning$4 = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning$2.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1$2 = warning$4;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
  var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable$2 = Object.prototype.propertyIsEnumerable;

  function toObject$2(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative$2() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign$2 = shouldUseNative$2() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject$2(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty$2.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols$2) {
  			symbols = getOwnPropertySymbols$2(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable$2.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$4 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1$2 = ReactPropTypesSecret$4;

  {
    var invariant$5 = invariant_1$2;
    var warning$5 = warning_1$2;
    var ReactPropTypesSecret$5 = ReactPropTypesSecret_1$2;
    var loggedTypeFailures$2 = {};
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes$2(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            invariant$5(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$5);
          } catch (ex) {
            error = ex;
          }
          warning$5(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
          if (error instanceof Error && !(error.message in loggedTypeFailures$2)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures$2[error.message] = true;

            var stack = getStack ? getStack() : '';

            warning$5(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
          }
        }
      }
    }
  }

  var checkPropTypes_1$2 = checkPropTypes$2;

  var factoryWithTypeCheckers$2 = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1$2) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            invariant_1$2(
              false,
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              warning_1$2(
                false,
                'You are manually calling a React.PropTypes validation ' +
                'function for the `%s` prop on `%s`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                propFullName,
                componentName
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunction_1$2.thatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$2);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        warning_1$2(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunction_1$2.thatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$2);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        warning_1$2(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunction_1$2.thatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          warning_1$2(
            false,
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received %s at index %s.',
            getPostfixForTypeWarning(checker),
            i
          );
          return emptyFunction_1$2.thatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$2) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$2);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign$2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$2);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1$2;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes$2 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
      Symbol.for &&
      Symbol.for('react.element')) ||
      0xeac7;

    var isValidElement = function(object) {
      return typeof object === 'object' &&
        object !== null &&
        object.$$typeof === REACT_ELEMENT_TYPE;
    };

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$2(isValidElement, throwOnDirectAccess);
  }
  });

  var canUseDOM = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

  exports['default'] = CAN_USE_DOM;
  });

  unwrapExports(canUseDOM);

  var canUsePassiveEventListeners_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = canUsePassiveEventListeners;



  var _canUseDOM2 = _interopRequireDefault(canUseDOM);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

  // Adapted from Modernizr
  // https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
  function testPassiveEventListeners() {
    if (!_canUseDOM2['default']) {
      return false;
    }

    if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
      return false;
    }

    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function () {
          function get() {
            supportsPassiveOption = true;
          }

          return get;
        }()
      });
      window.addEventListener('test', null, opts);
    } catch (e) {
      // do nothing
    }

    return supportsPassiveOption;
  }

  var memoized = void 0;

  function canUsePassiveEventListeners() {
    if (memoized === undefined) {
      memoized = testPassiveEventListeners();
    }
    return memoized;
  }
  });

  unwrapExports(canUsePassiveEventListeners_1);

  var normalizeEventOptions_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = normalizeEventOptions;



  var _canUsePassiveEventListeners2 = _interopRequireDefault(canUsePassiveEventListeners_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

  function normalizeEventOptions(eventOptions) {
    if (!eventOptions) {
      return undefined;
    }

    if (!(0, _canUsePassiveEventListeners2['default'])()) {
      // If the browser does not support the passive option, then it is expecting
      // a boolean for the options argument to specify whether it should use
      // capture or not. In more modern browsers, this is passed via the `capture`
      // option, so let's just hoist that value up.
      return !!eventOptions.capture;
    }

    return eventOptions;
  }
  });

  unwrapExports(normalizeEventOptions_1);

  var eventOptionsKey_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = eventOptionsKey;
  /* eslint-disable no-bitwise */

  /**
   * Generate a unique key for any set of event options
   */
  function eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) {
      return 0;
    }

    // If the browser does not support passive event listeners, the normalized
    // event options will be a boolean.
    if (normalizedEventOptions === true) {
      return 100;
    }

    // At this point, the browser supports passive event listeners, so we expect
    // the event options to be an object with possible properties of capture,
    // passive, and once.
    //
    // We want to consistently return the same value, regardless of the order of
    // these properties, so let's use binary maths to assign each property to a
    // bit, and then add those together (with an offset to account for the
    // booleans at the beginning of this function).
    var capture = normalizedEventOptions.capture << 0;
    var passive = normalizedEventOptions.passive << 1;
    var once = normalizedEventOptions.once << 2;
    return capture + passive + once;
  }
  });

  unwrapExports(eventOptionsKey_1);

  var TargetEventHandlers_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



  var _eventOptionsKey2 = _interopRequireDefault(eventOptionsKey_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function ensureCanMutateNextEventHandlers(eventHandlers) {
    if (eventHandlers.handlers === eventHandlers.nextHandlers) {
      // eslint-disable-next-line no-param-reassign
      eventHandlers.nextHandlers = eventHandlers.handlers.slice();
    }
  }

  var TargetEventHandlers = function () {
    function TargetEventHandlers(target) {
      _classCallCheck(this, TargetEventHandlers);

      this.target = target;
      this.events = {};
    }

    _createClass(TargetEventHandlers, [{
      key: 'getEventHandlers',
      value: function () {
        function getEventHandlers(eventName, options) {
          var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

          if (!this.events[key]) {
            this.events[key] = {
              handlers: [],
              handleEvent: undefined
            };
            this.events[key].nextHandlers = this.events[key].handlers;
          }

          return this.events[key];
        }

        return getEventHandlers;
      }()
    }, {
      key: 'handleEvent',
      value: function () {
        function handleEvent(eventName, options, event) {
          var eventHandlers = this.getEventHandlers(eventName, options);
          eventHandlers.handlers = eventHandlers.nextHandlers;
          eventHandlers.handlers.forEach(function (handler) {
            if (handler) {
              // We need to check for presence here because a handler function may
              // cause later handlers to get removed. This can happen if you for
              // instance have a waypoint that unmounts another waypoint as part of an
              // onEnter/onLeave handler.
              handler(event);
            }
          });
        }

        return handleEvent;
      }()
    }, {
      key: 'add',
      value: function () {
        function add(eventName, listener, options) {
          var _this = this;

          // options has already been normalized at this point.
          var eventHandlers = this.getEventHandlers(eventName, options);

          ensureCanMutateNextEventHandlers(eventHandlers);

          if (eventHandlers.nextHandlers.length === 0) {
            eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

            this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.nextHandlers.push(listener);

          var isSubscribed = true;
          var unsubscribe = function () {
            function unsubscribe() {
              if (!isSubscribed) {
                return;
              }

              isSubscribed = false;

              ensureCanMutateNextEventHandlers(eventHandlers);
              var index = eventHandlers.nextHandlers.indexOf(listener);
              eventHandlers.nextHandlers.splice(index, 1);

              if (eventHandlers.nextHandlers.length === 0) {
                // All event handlers have been removed, so we want to remove the event
                // listener from the target node.

                if (_this.target) {
                  // There can be a race condition where the target may no longer exist
                  // when this function is called, e.g. when a React component is
                  // unmounting. Guarding against this prevents the following error:
                  //
                  //   Cannot read property 'removeEventListener' of undefined
                  _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
                }

                eventHandlers.handleEvent = undefined;
              }
            }

            return unsubscribe;
          }();
          return unsubscribe;
        }

        return add;
      }()
    }]);

    return TargetEventHandlers;
  }();

  exports['default'] = TargetEventHandlers;
  });

  unwrapExports(TargetEventHandlers_1);

  var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EVENT_HANDLERS_KEY = undefined;
  exports.addEventListener = addEventListener;
  exports.removeEventListener = removeEventListener;



  var _normalizeEventOptions2 = _interopRequireDefault(normalizeEventOptions_1);



  var _TargetEventHandlers2 = _interopRequireDefault(TargetEventHandlers_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

  // Export to make testing possible.
  var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

  function addEventListener(target, eventName, listener, options) {
    if (!target[EVENT_HANDLERS_KEY]) {
      // eslint-disable-next-line no-param-reassign
      target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
    }
    var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
    return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
  }

  // Deprecated
  function removeEventListener(unsubscribeFn) {
    unsubscribeFn();
  }
  });

  unwrapExports(lib);
  var lib_1 = lib.EVENT_HANDLERS_KEY;
  var lib_2 = lib.addEventListener;
  var lib_3 = lib.removeEventListener;

  function _interopDefault$1 (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }


  var PropTypes = _interopDefault$1(propTypes$2);
  var React$1 = _interopDefault$1(React);

  /**
   * Attempts to parse the offset provided as a prop as a percentage. For
   * instance, if the component has been provided with the string "20%" as
   * a value of one of the offset props. If the value matches, then it returns
   * a numeric version of the prop. For instance, "20%" would become `0.2`.
   * If `str` isn't a percentage, then `undefined` will be returned.
   *
   * @param {string} str The value of an offset prop to be converted to a
   *   number.
   * @return {number|undefined} The numeric version of `str`. Undefined if `str`
   *   was not a percentage.
   */
  function parseOffsetAsPercentage(str) {
    if (str.slice(-1) === '%') {
      return parseFloat(str.slice(0, -1)) / 100;
    }
  }

  /**
   * Attempts to parse the offset provided as a prop as a pixel value. If
   * parsing fails, then `undefined` is returned. Three examples of values that
   * will be successfully parsed are:
   * `20`
   * "20px"
   * "20"
   *
   * @param {string|number} str A string of the form "{number}" or "{number}px",
   *   or just a number.
   * @return {number|undefined} The numeric version of `str`. Undefined if `str`
   *   was neither a number nor string ending in "px".
   */
  function parseOffsetAsPixels(str) {
    if (!isNaN(parseFloat(str)) && isFinite(str)) {
      return parseFloat(str);
    } else if (str.slice(-2) === 'px') {
      return parseFloat(str.slice(0, -2));
    }
  }

  /**
   * @param {string|number} offset
   * @param {number} contextHeight
   * @return {number} A number representing `offset` converted into pixels.
   */
  function computeOffsetPixels(offset, contextHeight) {
    var pixelOffset = parseOffsetAsPixels(offset);

    if (typeof pixelOffset === 'number') {
      return pixelOffset;
    }

    var percentOffset = parseOffsetAsPercentage(offset);
    if (typeof percentOffset === 'number') {
      return percentOffset * contextHeight;
    }
  }

  var constants = {
    above: 'above',
    inside: 'inside',
    below: 'below',
    invisible: 'invisible'
  };

  function debugLog() {
    {
      console.log(arguments); // eslint-disable-line no-console
    }
  }

  var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

  /**
   * Raise an error if more that one child was provided to "children"
   *
   * @param {?React.element} children
   * @return {undefined}
   */
  function ensureChildrenIsValid(children) {
    if (children) {
      try {
        React$1.Children.only(children);
      } catch (e) {
        throw new Error(errorMessage);
      }
    }
  }

  /**
   * When an element's type is a string, it represents a DOM node with that tag name
   * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
   *
   * @param {React.element} Component
   * @return {bool} Whether the component is a DOM Element
   */
  function isDOMElement(Component) {
    return typeof Component.type === 'string';
  }

  var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

  /**
   * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
   *
   * @param {?React.element} children
   * @param {?HTMLElement} ref
   * @return {undefined}
   */
  function ensureRefIsProvidedByChild(children, ref) {
    if (children && !isDOMElement(children) && !ref) {
      throw new Error(errorMessage$1);
    }
  }

  /**
   * @param {object} bounds An object with bounds data for the waypoint and
   *   scrollable parent
   * @return {string} The current position of the waypoint in relation to the
   *   visible portion of the scrollable parent. One of `constants.above`,
   *   `constants.below`, or `constants.inside`.
   */
  function getCurrentPosition(bounds) {
    if (bounds.viewportBottom - bounds.viewportTop === 0) {
      return constants.invisible;
    }

    // top is within the viewport
    if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
      return constants.inside;
    }

    // bottom is within the viewport
    if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
      return constants.inside;
    }

    // top is above the viewport and bottom is below the viewport
    if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
      return constants.inside;
    }

    if (bounds.viewportBottom < bounds.waypointTop) {
      return constants.below;
    }

    if (bounds.waypointTop < bounds.viewportTop) {
      return constants.above;
    }

    return constants.invisible;
  }

  var timeout = void 0;
  var timeoutQueue = [];

  function onNextTick(cb) {
    timeoutQueue.push(cb);

    if (!timeout) {
      timeout = setTimeout(function () {
        timeout = null;

        // Drain the timeoutQueue
        var item = void 0;
        // eslint-disable-next-line no-cond-assign
        while (item = timeoutQueue.shift()) {
          item();
        }
      }, 0);
    }

    var isSubscribed = true;

    return function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        var index = timeoutQueue.indexOf(cb);
        if (index === -1) {
          return;
        }

        timeoutQueue.splice(index, 1);

        if (!timeoutQueue.length && timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
      }

      return unsubscribe;
    }();
  }

  function resolveScrollableAncestorProp(scrollableAncestor) {
    // When Waypoint is rendered on the server, `window` is not available.
    // To make Waypoint easier to work with, we allow this to be specified in
    // string form and safely convert to `window` here.
    if (scrollableAncestor === 'window') {
      return commonjsGlobal.window;
    }

    return scrollableAncestor;
  }

  var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  var defaultProps = {
    topOffset: '0px',
    bottomOffset: '0px',
    horizontal: false,
    onEnter: function () {
      function onEnter() {}

      return onEnter;
    }(),
    onLeave: function () {
      function onLeave() {}

      return onLeave;
    }(),
    onPositionChange: function () {
      function onPositionChange() {}

      return onPositionChange;
    }(),

    fireOnRapidScroll: true
  };

  /**
   * Calls a function when you scroll to the element.
   */

  var Waypoint = function (_React$Component) {
    _inherits$4(Waypoint, _React$Component);

    function Waypoint(props) {
      _classCallCheck$4(this, Waypoint);

      var _this = _possibleConstructorReturn$4(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

      _this.refElement = function (e) {
        return _this._ref = e;
      };
      return _this;
    }

    _createClass$4(Waypoint, [{
      key: 'componentWillMount',
      value: function () {
        function componentWillMount() {
          ensureChildrenIsValid(this.props.children);
        }

        return componentWillMount;
      }()
    }, {
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _this2 = this;

          if (!Waypoint.getWindow()) {
            return;
          }

          // this._ref may occasionally not be set at this time. To help ensure that
          // this works smoothly, we want to delay the initial execution until the
          // next tick.
          this.cancelInitialTimeout = onNextTick(function () {
            // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
            ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

            _this2._handleScroll = _this2._handleScroll.bind(_this2);
            _this2.scrollableAncestor = _this2._findScrollableAncestor();

            if (_this2.props.debug) {
              debugLog('scrollableAncestor', _this2.scrollableAncestor);
            }

            _this2.scrollEventListenerUnsubscribe = lib.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

            _this2.resizeEventListenerUnsubscribe = lib.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });

            _this2._handleScroll(null);
          });
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillReceiveProps',
      value: function () {
        function componentWillReceiveProps(newProps) {
          ensureChildrenIsValid(newProps.children);
        }

        return componentWillReceiveProps;
      }()
    }, {
      key: 'componentDidUpdate',
      value: function () {
        function componentDidUpdate() {
          if (!Waypoint.getWindow()) {
            return;
          }

          if (!this.scrollableAncestor) {
            // The Waypoint has not yet initialized.
            return;
          }

          // The element may have moved.
          this._handleScroll(null);
        }

        return componentDidUpdate;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          if (!Waypoint.getWindow()) {
            return;
          }

          if (this.scrollEventListenerUnsubscribe) {
            this.scrollEventListenerUnsubscribe();
          }
          if (this.resizeEventListenerUnsubscribe) {
            this.resizeEventListenerUnsubscribe();
          }

          if (this.cancelInitialTimeout) {
            this.cancelInitialTimeout();
          }
        }

        return componentWillUnmount;
      }()

      /**
       * Traverses up the DOM to find an ancestor container which has an overflow
       * style that allows for scrolling.
       *
       * @return {Object} the closest ancestor element with an overflow style that
       *   allows for scrolling. If none is found, the `window` object is returned
       *   as a fallback.
       */

    }, {
      key: '_findScrollableAncestor',
      value: function () {
        function _findScrollableAncestor() {
          var _props = this.props,
              horizontal = _props.horizontal,
              scrollableAncestor = _props.scrollableAncestor;


          if (scrollableAncestor) {
            return resolveScrollableAncestorProp(scrollableAncestor);
          }

          var node = this._ref;

          while (node.parentNode) {
            node = node.parentNode;

            if (node === document.body) {
              // We've reached all the way to the root node.
              return window;
            }

            var style = window.getComputedStyle(node);
            var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
            var overflow = overflowDirec || style.getPropertyValue('overflow');

            if (overflow === 'auto' || overflow === 'scroll') {
              return node;
            }
          }

          // A scrollable ancestor element was not found, which means that we need to
          // do stuff on window.
          return window;
        }

        return _findScrollableAncestor;
      }()

      /**
       * @param {Object} event the native scroll event coming from the scrollable
       *   ancestor, or resize event coming from the window. Will be undefined if
       *   called by a React lifecyle method
       */

    }, {
      key: '_handleScroll',
      value: function () {
        function _handleScroll(event) {
          if (!this._ref) {
            // There's a chance we end up here after the component has been unmounted.
            return;
          }

          var bounds = this._getBounds();
          var currentPosition = getCurrentPosition(bounds);
          var previousPosition = this._previousPosition;

          if (this.props.debug) {
            debugLog('currentPosition', currentPosition);
            debugLog('previousPosition', previousPosition);
          }

          // Save previous position as early as possible to prevent cycles
          this._previousPosition = currentPosition;

          if (previousPosition === currentPosition) {
            // No change since last trigger
            return;
          }

          var callbackArg = {
            currentPosition: currentPosition,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          };
          this.props.onPositionChange.call(this, callbackArg);

          if (currentPosition === constants.inside) {
            this.props.onEnter.call(this, callbackArg);
          } else if (previousPosition === constants.inside) {
            this.props.onLeave.call(this, callbackArg);
          }

          var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
          var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

          if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
            // If the scroll event isn't fired often enough to occur while the
            // waypoint was visible, we trigger both callbacks anyway.
            this.props.onEnter.call(this, {
              currentPosition: constants.inside,
              previousPosition: previousPosition,
              event: event,
              waypointTop: bounds.waypointTop,
              waypointBottom: bounds.waypointBottom,
              viewportTop: bounds.viewportTop,
              viewportBottom: bounds.viewportBottom
            });
            this.props.onLeave.call(this, {
              currentPosition: currentPosition,
              previousPosition: constants.inside,
              event: event,
              waypointTop: bounds.waypointTop,
              waypointBottom: bounds.waypointBottom,
              viewportTop: bounds.viewportTop,
              viewportBottom: bounds.viewportBottom
            });
          }
        }

        return _handleScroll;
      }()
    }, {
      key: '_getBounds',
      value: function () {
        function _getBounds() {
          var horizontal = this.props.horizontal;

          var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
              left = _ref$getBoundingClien.left,
              top = _ref$getBoundingClien.top,
              right = _ref$getBoundingClien.right,
              bottom = _ref$getBoundingClien.bottom;

          var waypointTop = horizontal ? left : top;
          var waypointBottom = horizontal ? right : bottom;

          var contextHeight = void 0;
          var contextScrollTop = void 0;
          if (this.scrollableAncestor === window) {
            contextHeight = horizontal ? window.innerWidth : window.innerHeight;
            contextScrollTop = 0;
          } else {
            contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
            contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
          }

          if (this.props.debug) {
            debugLog('waypoint top', waypointTop);
            debugLog('waypoint bottom', waypointBottom);
            debugLog('scrollableAncestor height', contextHeight);
            debugLog('scrollableAncestor scrollTop', contextScrollTop);
          }

          var _props2 = this.props,
              bottomOffset = _props2.bottomOffset,
              topOffset = _props2.topOffset;

          var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
          var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
          var contextBottom = contextScrollTop + contextHeight;

          return {
            waypointTop: waypointTop,
            waypointBottom: waypointBottom,
            viewportTop: contextScrollTop + topOffsetPx,
            viewportBottom: contextBottom - bottomOffsetPx
          };
        }

        return _getBounds;
      }()

      /**
       * @return {Object}
       */

    }, {
      key: 'render',
      value: function () {
        function render() {
          var _this3 = this;

          var children = this.props.children;


          if (!children) {
            // We need an element that we can locate in the DOM to determine where it is
            // rendered relative to the top of its context.
            return React$1.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
          }

          if (isDOMElement(children)) {
            var ref = function () {
              function ref(node) {
                _this3.refElement(node);
                if (children.ref) {
                  children.ref(node);
                }
              }

              return ref;
            }();

            return React$1.cloneElement(children, { ref: ref });
          }

          return React$1.cloneElement(children, { innerRef: this.refElement });
        }

        return render;
      }()
    }]);

    return Waypoint;
  }(React$1.Component);

  Waypoint.propTypes = {
    children: PropTypes.node,
    debug: PropTypes.bool,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
    onPositionChange: PropTypes.func,
    fireOnRapidScroll: PropTypes.bool,
    scrollableAncestor: PropTypes.any,
    horizontal: PropTypes.bool,

    // `topOffset` can either be a number, in which case its a distance from the
    // top of the container in pixels, or a string value. Valid string values are
    // of the form "20px", which is parsed as pixels, or "20%", which is parsed
    // as a percentage of the height of the containing element.
    // For instance, if you pass "-20%", and the containing element is 100px tall,
    // then the waypoint will be triggered when it has been scrolled 20px beyond
    // the top of the containing element.
    topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    // `bottomOffset` is like `topOffset`, but for the bottom of the container.
    bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  Waypoint.above = constants.above;
  Waypoint.below = constants.below;
  Waypoint.inside = constants.inside;
  Waypoint.invisible = constants.invisible;
  Waypoint.getWindow = function () {
    if (typeof window !== 'undefined') {
      return window;
    }
  };
  Waypoint.defaultProps = defaultProps;
  Waypoint.displayName = 'Waypoint';

  var cjs = Waypoint;

  function _typeof$4(obj) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
      _typeof$4 = function _typeof$$1(obj) {
        return _typeof(obj);
      };
    } else {
      _typeof$4 = function _typeof$$1(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
      };
    }

    return _typeof$4(obj);
  }

  function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$4(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$5(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$4(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn$5(self, call) {
    if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized$4(self);
  }

  function _getPrototypeOf$4(o) {
    _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf$$1(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$4(o);
  }

  function _inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf$4(subClass, superClass);
  }

  function _setPrototypeOf$4(o, p) {
    _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf$$1(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$4(o, p);
  }

  function _assertThisInitialized$4(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _defineProperty$4(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var ScrollPoint =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits$5(ScrollPoint, _React$Component);

    function ScrollPoint() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$5(this, ScrollPoint);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$5(this, (_getPrototypeOf2 = _getPrototypeOf$4(ScrollPoint)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$4(_assertThisInitialized$4(_assertThisInitialized$4(_this)), "handlePositionChange", function (pos) {// console.log(pos);
      });

      _defineProperty$4(_assertThisInitialized$4(_assertThisInitialized$4(_this)), "handleEnter", function (pos) {
        _this.props.onEnter(_this.props.id, pos);
      });

      _defineProperty$4(_assertThisInitialized$4(_assertThisInitialized$4(_this)), "handleLeave", function (pos) {
        _this.props.onLeave(_this.props.id, pos);
      });

      return _this;
    }

    _createClass$5(ScrollPoint, [{
      key: "render",
      value: function render() {
        return React.createElement("div", {
          id: this.props.id,
          className: this.props.className
        }, React.createElement(cjs, {
          scrollableAncestor: this.props.scrollableAncestor,
          topOffset: this.props.topOffset,
          bottomOffset: this.props.bottomOffset,
          onPositionChange: this.handlePositionChange,
          onEnter: this.handleEnter,
          onLeave: this.handleLeave
        }), this.props.children);
      }
    }]);

    return ScrollPoint;
  }(React.Component);

  _defineProperty$4(ScrollPoint, "propTypes", {
    /** 当 waypoint 进入 viewport 时的回到 */
    onEnter: propTypes$2.func,

    /** 当 waypoint 离开 viewport 时的回到 */
    onLeave: propTypes$2.func,

    /**
     * top 偏移，可以是 20、'20px'、'20%'
     */
    topOffset: propTypes$2.oneOfType([propTypes$2.string, propTypes$2.number]),

    /**
     * 底部偏移
     */
    bottomOffset: propTypes$2.oneOfType([propTypes$2.string, propTypes$2.number]),

    /**
     * Scrollable Ancestor - A custom ancestor to determine if the
     * target is visible in it. This is useful in cases where
     * you do not want the immediate scrollable ancestor to be
     * the container. For example, when your target is in a div
     * that has overflow auto but you are detecting onEnter based
     * on the window.
     *
     * This should typically be a reference to a DOM node, but it will also work
     * to pass it the string "window" if you are using server rendering.
     */
    scrollableAncestor: propTypes$2.any,

    /** className */
    className: propTypes$2.string,

    /** waypoint 标识符 */
    id: propTypes$2.oneOfType([propTypes$2.string, propTypes$2.number]),

    /** children */
    children: propTypes$2.oneOfType([propTypes$2.arrayOf(propTypes$2.node), propTypes$2.node])
  });

  _defineProperty$4(ScrollPoint, "defaultProps", {
    id: null,
    topOffset: 0,
    bottomOffset: 0,
    scrollableAncestor: undefined,
    onEnter: function onEnter() {},
    onLeave: function onLeave() {}
  });

  function _typeof$5(obj) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
      _typeof$5 = function _typeof$$1(obj) {
        return _typeof(obj);
      };
    } else {
      _typeof$5 = function _typeof$$1(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
      };
    }

    return _typeof$5(obj);
  }

  function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$5(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$6(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$5(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn$6(self, call) {
    if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized$5(self);
  }

  function _getPrototypeOf$5(o) {
    _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf$$1(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$5(o);
  }

  function _inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf$5(subClass, superClass);
  }

  function _setPrototypeOf$5(o, p) {
    _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf$$1(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$5(o, p);
  }

  function _assertThisInitialized$5(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _defineProperty$5(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var ScrollSpy =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits$6(ScrollSpy, _React$Component);

    function ScrollSpy() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$6(this, ScrollSpy);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$6(this, (_getPrototypeOf2 = _getPrototypeOf$5(ScrollSpy)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$5(_assertThisInitialized$5(_assertThisInitialized$5(_this)), "insides", []);

      _defineProperty$5(_assertThisInitialized$5(_assertThisInitialized$5(_this)), "current", undefined);

      _defineProperty$5(_assertThisInitialized$5(_assertThisInitialized$5(_this)), "childrenIdx", {});

      _defineProperty$5(_assertThisInitialized$5(_assertThisInitialized$5(_this)), "firstId", void 0);

      _defineProperty$5(_assertThisInitialized$5(_assertThisInitialized$5(_this)), "lastId", void 0);

      return _this;
    }

    _createClass$6(ScrollSpy, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.insides = [];
          this.current = undefined;
          this.childrenIdx = {};
          this.firstId = null;
          this.lastId = null;
        }
      }
    }, {
      key: "triggerChange",
      value: function triggerChange() {
        var _this2 = this;

        if (this.insides.length > 0) {
          // 排序，取当前可视范围的第一个
          this.insides.sort(function (a, b) {
            return _this2.childrenIdx[a] - _this2.childrenIdx[b];
          });

          if (this.current !== this.insides[0]) {
            this.current = this.insides[0];
            var rt = this.current;

            if (rt === ScrollSpy.topKey) {
              rt = this.firstId;
            }

            if (rt === ScrollSpy.bottomKey) {
              rt = this.lastId;
            }

            this.props.onChange(rt);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement("div", {
          className: this.props.className
        }, this.bindChildren);
      }
    }, {
      key: "bindChildren",
      get: function get() {
        var _this3 = this;

        var children = React.Children.toArray(this.props.children); // children.unshift(
        //     <ScrollPoint id={`${ScrollSpy.topKey}`}/>
        // );
        // children.push(
        //     <ScrollPoint id={`${ScrollSpy.bottomKey}`}/>
        // );

        this.firstId = null;
        this.lastId = null;
        var boundChildren = React.Children.map(children, function (child, idx) {
          if (child.type === ScrollPoint) {
            var id = child.props.id;

            if (_this3.firstId == null && id !== ScrollSpy.topKey) {
              _this3.firstId = id;
            }

            if (id !== ScrollSpy.bottomKey) {
              _this3.lastId = id;
            }

            _this3.childrenIdx[id] = idx;
            return React.cloneElement(child, {
              idx: idx,
              topOffset: _this3.props.topOffset,
              bottomOffset: _this3.props.bottomOffset,
              className: child.props.className,
              onEnter: function onEnter(id, pos) {
                _this3.insides.push(id);

                _this3.triggerChange();

                _this3.props.onEnter(id, _this3.insides);
              },
              onLeave: function onLeave(id, pos) {
                _this3.insides.splice(_this3.insides.indexOf(id), 1);

                _this3.triggerChange();

                _this3.props.onLeave(id, _this3.insides);
              }
            });
          }

          return child;
        });
        this.childrenIdx[ScrollSpy.topKey] = -2;
        this.childrenIdx[ScrollSpy.bottomKey] = -1;
        return boundChildren;
      }
    }]);

    return ScrollSpy;
  }(React.Component);

  _defineProperty$5(ScrollSpy, "propTypes", {
    /** 名字标识 */
    name: propTypes$2.oneOfType([propTypes$2.string, propTypes$2.number]),

    /** 当 waypoint 进入 viewport 时的回到 */
    onEnter: propTypes$2.func,

    /** 当 waypoint 离开 viewport 时的回到 */
    onLeave: propTypes$2.func,

    /**
      * top 偏移，可以是 20、'20px'、'20%'
      */
    topOffset: propTypes$2.oneOfType([propTypes$2.string, propTypes$2.number]),

    /**
      * 底部偏移
      */
    bottomOffset: propTypes$2.oneOfType([propTypes$2.string, propTypes$2.number]),

    /** viewport 内容变化时的回调 */
    onChange: propTypes$2.func,

    /** className */
    className: propTypes$2.string,

    /** children */
    children: propTypes$2.oneOfType([propTypes$2.arrayOf(propTypes$2.node), propTypes$2.node])
  });

  _defineProperty$5(ScrollSpy, "defaultProps", {
    topOffset: 0,
    bottomOffset: 0,
    className: null,
    name: '',
    onChange: function onChange() {},
    onEnter: function onEnter() {},
    onLeave: function onLeave() {}
  });

  _defineProperty$5(ScrollSpy, "bottomKey", '$bottom');

  _defineProperty$5(ScrollSpy, "topKey", '$top');

  ScrollSpy.Point = ScrollPoint;

  function _typeof$6(obj) {
    if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
      _typeof$6 = function _typeof$$1(obj) {
        return _typeof(obj);
      };
    } else {
      _typeof$6 = function _typeof$$1(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
      };
    }

    return _typeof$6(obj);
  }

  function _objectWithoutProperties$4(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose$4(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose$4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$6(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$7(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$6(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn$7(self, call) {
    if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized$6(self);
  }

  function _getPrototypeOf$6(o) {
    _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf$$1(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$6(o);
  }

  function _inherits$7(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf$6(subClass, superClass);
  }

  function _setPrototypeOf$6(o, p) {
    _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf$$1(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf$6(o, p);
  }

  function _assertThisInitialized$6(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _defineProperty$6(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var InfiniteScroll =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits$7(InfiniteScroll, _React$Component);

    function InfiniteScroll() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$7(this, InfiniteScroll);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn$7(this, (_getPrototypeOf2 = _getPrototypeOf$6(InfiniteScroll)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$6(_assertThisInitialized$6(_assertThisInitialized$6(_this)), "scrollListener", function () {
        if (_this.isHidden) return;

        if (_this.offset < Number(_this.props.threshold)) {
          _this.detachScrollListener();

          if (typeof _this.props.loadMore === 'function' && !_this.props.loading) {
            _this.props.loadMore(_this.props.pageStart + 1);
          }
        }
      });

      return _this;
    }

    _createClass$7(InfiniteScroll, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.attachScrollListener();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(nextProps) {
        this.attachScrollListener();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.detachScrollListener();
      } // Set a defaut loader for all your `InfiniteScroll` components

    }, {
      key: "setDefaultLoader",
      value: function setDefaultLoader(loader) {
        this.defaultLoader = loader;
      }
    }, {
      key: "detachScrollListener",
      value: function detachScrollListener() {
        var scrollEl = window;

        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }

        scrollEl.removeEventListener('scroll', this.scrollListener, this.props.useCapture);
        scrollEl.removeEventListener('resize', this.scrollListener, this.props.useCapture);
      }
    }, {
      key: "attachScrollListener",
      value: function attachScrollListener() {
        if (!this.props.hasMore) {
          return;
        }

        var scrollEl = window;

        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }

        scrollEl.addEventListener('scroll', this.scrollListener, this.props.useCapture);
        scrollEl.addEventListener('resize', this.scrollListener, this.props.useCapture);

        if (this.props.initialLoad) {
          this.scrollListener();
        }
      }
    }, {
      key: "calculateTopPosition",
      value: function calculateTopPosition(el) {
        if (!el) {
          return 0;
        }

        return el.offsetTop + this.calculateTopPosition(el.offsetParent);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            children = _this$props.children,
            element = _this$props.element,
            hasMore = _this$props.hasMore,
            initialLoad = _this$props.initialLoad,
            isReverse = _this$props.isReverse,
            loader = _this$props.loader,
            loadMore = _this$props.loadMore,
            pageStart = _this$props.pageStart,
            ref = _this$props.ref,
            threshold = _this$props.threshold,
            useCapture = _this$props.useCapture,
            useWindow = _this$props.useWindow,
            loading = _this$props.loading,
            rest = _objectWithoutProperties$4(_this$props, ["children", "element", "hasMore", "initialLoad", "isReverse", "loader", "loadMore", "pageStart", "ref", "threshold", "useCapture", "useWindow", "loading"]);

        rest.ref = function (node) {
          _this2.scrollComponent = node;

          if (ref) {
            ref(node);
          }
        };

        var childrenArray = [children];

        if (hasMore) {
          if (loader) {
            isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
          } else if (this.defaultLoader) {
            isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
          }
        }

        return React.createElement.apply(React, [element, rest].concat(childrenArray));
      }
    }, {
      key: "isHidden",
      get: function get() {
        var elem = this.scrollComponent;
        return elem && !(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
      }
    }, {
      key: "offset",
      get: function get() {
        var el = this.scrollComponent;
        var scrollEl = window;
        var offset;

        if (this.props.useWindow) {
          var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (this.props.isReverse) {
            offset = scrollTop;
          } else {
            offset = this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
          }
        } else if (this.props.isReverse) {
          offset = el.parentNode.scrollTop;
        } else {
          offset = el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight;
        }

        return offset;
      }
    }]);

    return InfiniteScroll;
  }(React.Component);

  _defineProperty$6(InfiniteScroll, "propTypes", {
    /** 是否使用 window 作为滚动容器 */
    useWindow: propTypes$2.bool,

    /** dom type */
    element: propTypes$2.string,

    /** 是否在加载 */
    loading: propTypes$2.bool,

    /** 是否还有更多 */
    hasMore: propTypes$2.bool,

    /** 初始化是否触发加载 */
    initialLoad: propTypes$2.bool,

    /** 起始页码 */
    pageStart: propTypes$2.number,

    /** 滚动对象 ref */
    ref: propTypes$2.func,

    /** 滚动阈值，越小越敏感 */
    threshold: propTypes$2.number,

    /** 是否反向滚动 */
    isReverse: propTypes$2.bool,

    /** event listener useCapture */
    useCapture: propTypes$2.bool,

    /** 加载更多的方法 */
    loadMore: propTypes$2.func,

    /** 自定义加载内容 */
    loader: propTypes$2.oneOfType([propTypes$2.arrayOf(propTypes$2.node), propTypes$2.node, propTypes$2.element]),

    /** children */
    children: propTypes$2.oneOfType([propTypes$2.arrayOf(propTypes$2.node), propTypes$2.node])
  });

  _defineProperty$6(InfiniteScroll, "defaultProps", {
    element: 'div',
    loading: false,
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    ref: null,
    threshold: 50,
    useWindow: false,
    isReverse: false,
    useCapture: false,
    loader: React.createElement("li", {
      role: "presentation",
      className: "disabled"
    }, React.createElement("a", {
      role: "menuitem",
      href: "#"
    }, React.createElement("i", {
      className: "n-loading-icon"
    }), "\xA0 \u52A0\u8F7D\u4E2D\u2026"))
  });

  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT$1 = 'Expected a function';

  /** Used as references for various `Number` constants. */
  var NAN$1 = 0 / 0;

  /** `Object#toString` result references. */
  var symbolTag$1 = '[object Symbol]';

  /** Used to match leading and trailing whitespace. */
  var reTrim$1 = /^\s+|\s+$/g;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary$1 = /^0b[01]+$/i;

  /** Used to detect octal string values. */
  var reIsOctal$1 = /^0o[0-7]+$/i;

  /** Built-in method references without a dependency on `root`. */
  var freeParseInt$1 = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString$1 = objectProto$1.toString;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax$1 = Math.max,
      nativeMin$1 = Math.min;

  /**
   * Gets the timestamp of the number of milliseconds that have elapsed since
   * the Unix epoch (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Date
   * @returns {number} Returns the timestamp.
   * @example
   *
   * _.defer(function(stamp) {
   *   console.log(_.now() - stamp);
   * }, _.now());
   * // => Logs the number of milliseconds it took for the deferred invocation.
   */
  var now$1 = function() {
    return root$1.Date.now();
  };

  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   * Provide `options` to indicate whether `func` should be invoked on the
   * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
   * with the last arguments provided to the debounced function. Subsequent
   * calls to the debounced function return the result of the last `func`
   * invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the debounced function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.debounce` and `_.throttle`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to debounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=false]
   *  Specify invoking on the leading edge of the timeout.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * jQuery(element).on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * }));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
   * var source = new EventSource('/stream');
   * jQuery(source).on('message', debounced);
   *
   * // Cancel the trailing debounced invocation.
   * jQuery(window).on('popstate', debounced.cancel);
   */
  function debounce$1(func, wait, options) {
    var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;

    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$1);
    }
    wait = toNumber$1(wait) || 0;
    if (isObject$1(options)) {
      leading = !!options.leading;
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }

    function invokeFunc(time) {
      var args = lastArgs,
          thisArg = lastThis;

      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }

    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time;
      // Start the timer for the trailing edge.
      timerId = setTimeout(timerExpired, wait);
      // Invoke the leading edge.
      return leading ? invokeFunc(time) : result;
    }

    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime,
          result = wait - timeSinceLastCall;

      return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
    }

    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime;

      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
        (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
    }

    function timerExpired() {
      var time = now$1();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      // Restart the timer.
      timerId = setTimeout(timerExpired, remainingWait(time));
    }

    function trailingEdge(time) {
      timerId = undefined;

      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = undefined;
      return result;
    }

    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }

    function flush() {
      return timerId === undefined ? result : trailingEdge(now$1());
    }

    function debounced() {
      var time = now$1(),
          isInvoking = shouldInvoke(time);

      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;

      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject$1(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike$1(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol$1(value) {
    return typeof value == 'symbol' ||
      (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
  }

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  function toNumber$1(value) {
    if (typeof value == 'number') {
      return value;
    }
    if (isSymbol$1(value)) {
      return NAN$1;
    }
    if (isObject$1(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject$1(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = value.replace(reTrim$1, '');
    var isBinary = reIsBinary$1.test(value);
    return (isBinary || reIsOctal$1.test(value))
      ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
      : (reIsBadHex$1.test(value) ? NAN$1 : +value);
  }

  var lodash_debounce$1 = debounce$1;

  /**
   * 远程搜索选择框
   */

  var RemoteSearchSelect =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(RemoteSearchSelect, _React$Component);

    function RemoteSearchSelect() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, RemoteSearchSelect);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RemoteSearchSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        opened: false
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSearch", lodash_debounce$1(function (value) {
        _this.props.onSearch(value);
      }, 500));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchTextChange", function (e) {
        _this.props.onSearchChange(e.target.value);

        _this.onSearch(e.target.value);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleToggleClick", function () {
        var disabled = _this.props.disabled;

        if (disabled) {
          return;
        }

        _this.toggle(!_this.state.opened);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleItemClick", function (item) {
        if (item.disabled) return;

        _this.toggle(false);

        _this.props.onChange(item[_this.props.valueField]);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLoad", function (page) {
        if (_this.props.total > _this.props.list.length) {
          _this.props.onLoad(page);
        }
      });

      return _this;
    }

    _createClass(RemoteSearchSelect, [{
      key: "handleClickOutside",
      value: function handleClickOutside(e) {
        this.toggle(false);
      }
    }, {
      key: "toggle",
      value: function toggle(opened) {
        this.setState({
          opened: opened
        });

        if (!opened) {
          this.props.onClose();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            total = _this$props.total,
            list = _this$props.list,
            disabled = _this$props.disabled;
        return React.createElement("div", {
          className: classnames({
            'tc-15-dropdown tc-15-dropdown-btn-style xl': true,
            'tc-15-menu-active': this.state.opened,
            'tc-15-menu-active-bottom': this.props.direction === 'bottom',
            disabled: disabled
          }),
          style: this.props.style
        }, React.createElement("a", {
          href: "javascript:",
          className: "tc-15-dropdown-link tc-15-input-text",
          style: this.props.innerStyle,
          onClick: this.handleToggleClick
        }, this.text, React.createElement("i", {
          className: "caret"
        })), React.createElement("div", {
          className: "dropdown-list-wrap"
        }, React.createElement("div", {
          className: "search-box search-box-simple m"
        }, React.createElement("div", {
          className: "search-input-wrap"
        }, React.createElement("textarea", {
          className: classnames('tc-15-input-text search-input', {
            loading: this.props.searching
          }),
          value: this.props.searchText,
          onChange: this.handleSearchTextChange,
          placeholder: this.props.searchLabel
        })), React.createElement("i", {
          className: "search-btn",
          type: "button",
          value: "\u641C\u7D22"
        })), React.createElement("div", {
          className: "tc-15-dropdown-menu"
        }, React.createElement(InfiniteScroll, {
          element: "ul",
          initialLoad: false,
          pageStart: this.props.page,
          hasMore: total !== 0 && total > list.length,
          loadMore: this.handleLoad,
          loading: this.props.loading
        }, this.list.length ? this.list.map(function (item) {
          return React.createElement("li", {
            className: classnames({
              disabled: item.disabled
            }),
            key: item.value,
            onClick: function onClick() {
              return _this2.handleItemClick(item);
            }
          }, React.createElement("a", {
            href: "javascript:"
          }, item.text));
        }) : React.createElement("li", {
          className: "disabled"
        }, React.createElement("a", {
          href: "javascript:"
        }, this.props.list.length === 0 ? '无结果' : '无搜索结果'))))));
      }
    }, {
      key: "list",
      get: function get() {
        var _this$props2 = this.props,
            list = _this$props2.list,
            textField = _this$props2.textField,
            valueField = _this$props2.valueField;
        return list.map(function (item) {
          return {
            text: item[textField],
            value: item[valueField],
            disabled: item.disabled
          };
        });
      }
    }, {
      key: "text",
      get: function get() {
        var _this3 = this;

        var rst = this.props.optionalLabel;
        var current = this.props.list.find(function (item) {
          return item.value === _this3.props.value;
        });

        if (current) {
          return current.text;
        }

        return rst;
      }
    }]);

    return RemoteSearchSelect;
  }(React.Component);

  _defineProperty(RemoteSearchSelect, "defaultProps", {
    direction: 'top',
    list: [],
    loading: false,
    total: 0,
    page: 0,
    optionalLabel: '请选择数据',
    searchLabel: '搜索数据',
    searchText: '',
    searching: false,
    value: null,
    textField: 'text',
    valueField: 'value',
    onSearchChange: function onSearchChange() {},
    onSearch: function onSearch() {},
    onChange: function onChange() {},
    onClose: function onClose() {},
    onBlur: function onBlur() {},
    onFocus: function onFocus() {},
    onLoad: function onLoad() {},
    innerStyle: {},
    disabled: false
  });

  var RemoteSearchSelect$1 = enhanceWithClickOutside(RemoteSearchSelect);

  /**
   * 浏览器原生下拉选择框
   */

  var Select =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Select);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (e) {
        var value = e.target.value;

        var item = _this.props.list.find(function (item) {
          return item.value.toString() === value.toString();
        });

        _this.props.onChange(item.value);
      });

      return _this;
    }

    _createClass(Select, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.selectFirstByDefault && this.props.list.length > 0 && (this.props.value == null || this.props.value === '')) {
          this.props.onChange(this.props.list[0].value);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            list = _this$props.list,
            placeholder = _this$props.placeholder,
            value = _this$props.value,
            onChange = _this$props.onChange,
            className = _this$props.className,
            selectFirstByDefault = _this$props.selectFirstByDefault,
            rest = _objectWithoutProperties(_this$props, ["list", "placeholder", "value", "onChange", "className", "selectFirstByDefault"]);

        if (placeholder) {
          list = [{
            text: placeholder,
            value: '',
            disabled: true
          }].concat(_toConsumableArray(list));
        }

        return React.createElement("select", _extends({
          className: classnames('tc-15-select', className),
          value: value == null ? '' : value,
          onChange: this.handleChange
        }, rest), list.map(function (item, i) {
          return React.createElement("option", {
            key: i,
            value: item.value,
            title: item.title // selected={item.selected}
            ,
            disabled: item.disabled
          }, item.text);
        }));
      }
    }]);

    return Select;
  }(React.Component);

  _defineProperty(Select, "defaultProps", {
    list: [],
    value: '',
    selectFirstByDefault: false,
    className: '',
    placeholder: null,
    onChange: function onChange(value) {}
  });

  /**
   * 本地搜索选择框
   */

  var SearchSelect =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(SearchSelect, _React$Component);

    function SearchSelect(props) {
      var _this;

      _classCallCheck(this, SearchSelect);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchSelect).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        opened: false,
        page: 0,
        filterList: [],
        searchTxt: ''
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchTextChange", function (e) {
        var searchTxt = e.target.value; // 本地搜索

        var filterList = _this.props.list.filter(function (row) {
          return row.text.indexOf(searchTxt) !== -1;
        });

        _this.setState({
          searchTxt: searchTxt,
          filterList: filterList,
          page: 0
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleItemClick", function (item) {
        if (item.disabled) return;
        _this.toggle(false);

        _this.props.onChange(item);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleToggleClick", function () {
        var disabled = _this.props.disabled;

        if (disabled) {
          return;
        }
        _this.toggle(!_this.state.opened);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLoad", function (page) {
        if (_this.total > _this.list.length) {
          _this.setState({
            page: page
          });
        }
      });

      _this.state.filterList = props.list;
      return _this;
    }

    _createClass(SearchSelect, [{
      key: "handleClickOutside",
      value: function handleClickOutside(e) {
        this.toggle(false);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setState({
          filterList: nextProps.list
        });
      }
    }, {
      key: "toggle",
      value: function toggle(opened) {
        this.setState({
          opened: opened,
          searchTxt: '',
          page: 0,
          filterList: this.props.list
        });

        if (!opened) {
          this.props.onClose();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var list = this.list,
            total = this.total;
        var textField = this.props.textField;
        var disabled = this.props.disabled;
        return React.createElement("div", {
          className: classnames({
            'tc-15-dropdown tc-15-dropdown-btn-style xl': true,
            'tc-15-menu-active': this.state.opened,
            'tc-15-menu-active-bottom': this.props.direction === 'bottom',
            disabled: disabled
          }),
          style: this.props.style
        }, React.createElement("a", {
          href: "javascript:",
          className: "tc-15-dropdown-link tc-15-input-text",
          style: this.props.innerStyle,
          onClick: this.handleToggleClick
        }, this.props.value ? this.props.value[textField] : this.props.placeholder || this.props.optionalLabel, React.createElement("i", {
          className: "caret"
        })), React.createElement("div", {
          className: "dropdown-list-wrap"
        }, React.createElement("div", {
          className: "search-box search-box-simple m"
        }, React.createElement("div", {
          className: "search-input-wrap"
        }, React.createElement("textarea", {
          className: classnames('tc-15-input-text search-input'),
          value: this.state.searchTxt,
          onChange: this.handleSearchTextChange,
          placeholder: this.props.searchLabel
        })), React.createElement("i", {
          className: "search-btn",
          type: "button",
          value: "\u641C\u7D22"
        })), React.createElement("div", {
          className: "tc-15-dropdown-menu"
        }, React.createElement(InfiniteScroll, {
          element: "ul",
                    style: { marginBottom: 0 },
          initialLoad: true,
          pageStart: this.state.page,
          hasMore: total !== 0 && total > list.length,
          loadMore: this.handleLoad,
          loading: false
        }, list.length ? list.map(function (item, idx) {
          return React.createElement("li", {
            className: classnames({
              disabled: item.disabled
            }),
            key: idx,
            onClick: function onClick() {
              return _this2.handleItemClick(item);
            }
          }, React.createElement("a", {
            href: "javascript:"
          }, item[textField]));
        }) : React.createElement("li", {
          key: "msg",
          className: "disabled"
        }, React.createElement("a", {
          href: "javascript:"
        }, list.length === 0 ? '无结果' : '无搜索结果'))))));
      }
    }, {
      key: "total",
      get: function get() {
        return this.state.filterList.length;
      }
    }, {
      key: "list",
      get: function get() {
        var _this$state = this.state,
            filterList = _this$state.filterList,
            page = _this$state.page;
        var _this$props = this.props,
            limit = _this$props.limit,
            textField = _this$props.textField,
            valueField = _this$props.valueField;
        var list = filterList.slice(0, (page + 1) * limit);
        return list.map(function (item) {
          return {
            text: item[textField],
            value: item[valueField],
            disabled: item.disabled
          };
        });
      }
    }]);

    return SearchSelect;
  }(React.Component);

  _defineProperty(SearchSelect, "defaultProps", {
    direction: 'top',
    list: [],
    limit: 30,
    loading: false,
    optionalLabel: '请选择数据',
    searchLabel: '搜索数据',
    value: null,
    textField: 'text',
    valueField: 'value',
    innerStyle: {},
    placeholder:'请选择',
    onChange: function onChange() {},
    onClose: function onClose() {},
    onBlur: function onBlur() {},
    onFocus: function onFocus() {},
    disabled: false
  });

  var SearchSelect$1 = enhanceWithClickOutside(SearchSelect);

  exports.GroupSearchSelect = GroupSearchSelect$1;
  exports.RemoteSearchSelect = RemoteSearchSelect$1;
  exports.Select = Select;
  exports.SearchSelect = SearchSelect$1;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
